import { useRouteError, useNavigate } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="h-screen flex flex-col justify-center items-center bg-gray-900 text-white p-4">
      <h1 className="text-3xl font-bold mb-4">Oops!</h1>
      <p className="mb-2">Something went wrong.</p>
      <p className="mb-6 text-red-400 text-center">
        {error.response
          ? error.statusText || error.message || error.data
          : "Something Unexpected!"}
      </p>

      <div className="flex gap-4">
        <button
          onClick={handleGoHome}
          className="px-5 py-2 rounded bg-blue-600 hover:bg-blue-700 transition-colors font-semibold"
        >
          Go Home
        </button>
        <button
          onClick={handleReload}
          className="px-5 py-2 rounded bg-gray-700 hover:bg-gray-600 transition-colors font-semibold"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
